<template>
    <div class="xeUsageChart heightMAX rounded" :class="{ 'is-overview-compact': isOverviewCompact }" style="overflow: hidden;">
        <div class="heightMAX" style="padding: 0">
            <!-- <div class="jvectormap-container " style="background-color: transparent; position:relative"> -->
            <drop @dragover="handleBodyDragOver(...arguments)" @drop="handleBodyDrop(...arguments)"
                class="heightMAX kbet-custom-reset">
                <div class="rounded kbet-widget-energy heightMAX" style="display: block;">
                    <p class="title">{{ $t(widget.title) }}</p>
                    <div class="usage-animation-area">
                        <div class="area-align">
                            <div class="info_area">
                                <dl class="info01">
                                    <dt>{{ $t("실시간 에너지 자립률") }}</dt>
                                    <dd class="selfRateValue font-roboto-slab">{{ selfRenceRate }}<span>%</span></dd>
                                </dl>
                                <dl class="info-style info02">
                                    <dt>{{ $t("1차에너지 소비량") }}</dt>
                                    <dd>
                                        <span class="pm-energy-text font-roboto-slab">{{ primaryCstnAmount }}</span>
                                        <span class="pm-energy-amount">&nbsp;kWh_p</span>
                                    </dd>
                                </dl>
                                <dl class="info-style info03">
                                    <dt>{{ $t("1차에너지 생산량") }}</dt>
                                    <dd>
                                        <span class="pm-energy-text font-roboto-slab">{{ primaryProdAmount }}</span>
                                        <span class="pm-energy-amount">&nbsp;kWh_p</span>
                                    </dd>
                                </dl>
                            </div>
                            <div class="img_area">
                                <div :style="bg1Style" class="bg1"></div>
                                <div :style="bg2Style" class="bg2"></div>
                                <div class="info04">
                                    <!-- compact: 흰 원(182/242)과 동일 스테이지에 아이콘+텍스트 -->
                                    <div class="info04-stage">
                                        <div class="bld-icon" :style="cssVars" aria-hidden="true"></div>
                                        <dl>
                                            <dt :style="cssVars">{{ $t("에너지 소비량") }}</dt>
                                            <dd>
                                                <span class="unit-amount-text font-roboto-slab">{{ cstnAmount }}</span><span
                                                    class="unit-text">&nbsp;kWh</span>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                        </div>
                        <p class="ex">
                            <i class="material-icons-outlined">info</i>{{ $t("실시간 자립률은 최근 1시간 자료로 계산됩니다.") }}
                        </p>
                    </div>
                </div>
                <!--// kbet-card-info -->
            </drop>
        </div>

        <b-modal ref="modalSetting" size="lg" title="설정 - 실시간 자립률" bodyClass="p-t-0 p-b-0" hide-footer>
            <self-rate-new-setting :initSetting="setting" @on-modal-cancel="onModalCancel" @on-modal-ok="onModalOK" />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import selfRateNewSetting from "./setting/xeSelfRateNewSetting.vue";

export default {
    props: ["showGrid", "widget", "cellSize", "on-remove-widget"],
    extends: xeBaseWidget,
    components: {
        selfRateNewSetting,
    },
    created() {
        if (!this.widget.bgIcon) {
            this.widget.bgIcon = "material flash_on";
        }
        if (!this.widget.bldImage) {
            this.widget.bldImage = "bg-icon03.png";
        }

        if (!this.widget.zoneIdx) {
            this.widget.zoneIdx = 1;
        }

        // console.log("xeSelfRateNew widget created");
    },
    mounted() {
        // console.log("xeSelfRateNew widget mounted");
    },
    data() {
        return {
            cstnAmount: null,
            primaryCstnAmount: null,
            primaryProdAmount: null,
            selfRenceRate: null,
            themeColor: global.xe.parseBool(localStorage.contentInverse)
                ? require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                : require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light,
            energyIntensityLevel: 0,
            energyConsumptLevel: 0,
        };
    },
    computed: {
        setting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
        cssVars() {
            // bldImage에 확장자가 없으면 .png 추가
            let imagePath = this.widget.bldImage || "bg-icon03.png";
            if (!imagePath.includes(".")) {
                imagePath = imagePath + ".png";
            }

            // 이미지별로 적절한 크기와 위치 설정
            let iconWidth = "139px";
            let iconHeight = "108px";
            let iconTop = "30px";
            let iconLeft = "34px";

            // factory.png는 더 큰 크기와 다른 위치
            if (imagePath === "factory.png") {
                iconWidth = "166px";
                iconHeight = "141px";
                iconTop = "0px";
                iconLeft = "9px";
            } else if (imagePath === "building.png") {
                // 빌딩 이미지
                iconWidth = "106px";
                iconHeight = "150px";
                iconTop = "-2px";
                iconLeft = "42px";
            } else if (imagePath === "bg-icon03.png") {
                // 소형 건물 이미지
                iconWidth = "139px";
                iconHeight = "108px";
                iconTop = "30px";
                iconLeft = "34px";
            }

            return {
                "--icon-bg": "url(/assets/xems/common/widget/selfRate/" + imagePath + ")",
                "--icon-width": iconWidth,
                "--icon-height": iconHeight,
                "--icon-top": iconTop,
                "--icon-left": iconLeft,
            };
        },
        animationDurationBg1() {
            let animationDuration;
            if (this.energyConsumptLevel === 0) {
                animationDuration = "45s";
            } else if (this.energyConsumptLevel === 1) {
                animationDuration = "35s";
            } else if (this.energyConsumptLevel === 2) {
                animationDuration = "25s";
            } else if (this.energyConsumptLevel === 3) {
                animationDuration = "15s";
            } else if (this.energyConsumptLevel >= 4) {
                animationDuration = "5s";
            }
            return {
                animation: `linear ${animationDuration} infinite loader`,
            };
        },
        animationDurationBg2() {
            let animationDuration;
            if (this.energyConsumptLevel == 0) {
                animationDuration = "45s";
            } else if (this.energyConsumptLevel == 1) {
                animationDuration = "35s";
            } else if (this.energyConsumptLevel == 2) {
                animationDuration = "25s";
            } else if (this.energyConsumptLevel == 3) {
                animationDuration = "15s";
            } else if (this.energyConsumptLevel >= 4) {
                animationDuration = "5s";
            }
            return {
                animation: `linear ${animationDuration} infinite loaderInner`,
            };
        },
        colorFilter() {
            let colorFilter;
            if (this.energyIntensityLevel == 0) {
                colorFilter = "grayscale(90%)";
            } else if (this.energyIntensityLevel == 1) {
                colorFilter = "grayscale(65%)";
            } else if (this.energyIntensityLevel == 2) {
                colorFilter = "grayscale(50%)";
            } else if (this.energyIntensityLevel == 3) {
                colorFilter = "grayscale(0%)";
            }
            return {
                filter: colorFilter,
            };
        },
        bg1Style() {
            return {
                ...this.animationDurationBg1,
                // ...this.colorFilter,
            };
        },
        bg2Style() {
            return {
                ...this.animationDurationBg2,
                ...this.colorFilter,
            };
        },
    },
    methods: {
        initSetting() { },
        applyData(data) {
            if (!data) return;

            if (data.cstnAmount == null || data.cstnAmount == undefined) this.cstnAmount = "-";
            else {
                this.cstnAmount = Number.isInteger(data.cstnAmount) ? data.cstnAmount : data.cstnAmount.toFixed(1);
            }

            if (data.primaryCstnAmount == null || data.primaryCstnAmount == undefined) this.primaryCstnAmount = "-";
            else {
                this.primaryCstnAmount = Number.isInteger(data.primaryCstnAmount)
                    ? data.primaryCstnAmount
                    : data.primaryCstnAmount.toFixed(1);
            }

            if (data.primaryProdAmount == null || data.primaryProdAmount == undefined) this.primaryProdAmount = "-";
            else {
                this.primaryProdAmount = Number.isInteger(data.primaryProdAmount)
                    ? data.primaryProdAmount
                    : data.primaryProdAmount.toFixed(1);
            }

            if (data.selfRenceRate == null || data.selfRenceRate == undefined) this.selfRenceRate = "-";
            else {
                // 자립률이 100 이상이거나 0이면 소수점 제거
                if (data.selfRenceRate >= 100 || data.selfRenceRate == 0)
                    this.selfRenceRate = data.selfRenceRate.toFixed(0);
                else {
                    this.selfRenceRate = Number.isInteger(data.selfRenceRate)
                        ? data.selfRenceRate
                        : data.selfRenceRate.toFixed(1);
                }
            }

            this.energyIntensityLevel = data.energyIntensityLevel;
            this.energyConsumptLevel = data.energyConsumptLevel;
        },
    },
};
</script>

<style scoped>
.selfRateValue {
    font-size: 61px;
}

.bg1 {
    position: absolute;
    top: 0;
    left: 9px;
    width: 251px;
    height: 250px;
    background: url(/assets/xems/common/widget/selfRate/circle_bg_01.png) 0 0 no-repeat;
}

.bg2 {
    position: absolute;
    top: 19px;
    left: 28px;
    width: 213px;
    height: 213px;
    background: url(/assets/xems/common/widget/selfRate/circle_bg_02.png) 0 0 no-repeat;
}

/* PC: 안내문을 area-align 밖으로 옮겨도 기존 위치에 가깝게 */
.usage-animation-area > .ex {
    position: absolute;
    bottom: 4px;
    left: 20px;
    margin: 0;
    font-size: 11px;
    font-weight: bold;
    z-index: 2;
}

/* 개요형 태블릿 가로 */
.xeUsageChart.is-overview-compact .usage-animation-area {
    min-width: 0 !important;
    min-height: 0 !important;
    width: 100%;
    height: calc(100% - 28px) !important;
    padding: 4px 6px 2px !important;
    overflow: hidden;
    display: flex !important;
    flex-direction: column;
    align-items: stretch !important;
    justify-content: flex-start !important;
    position: relative;
    box-sizing: border-box;
}

.xeUsageChart.is-overview-compact .area-align {
    position: relative;
    width: 100% !important;
    max-width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    height: auto !important;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    overflow: hidden;
}

.xeUsageChart.is-overview-compact .info_area {
    width: 55% !important;
    max-width: 55%;
    min-width: 0;
    padding-left: 6px !important;
    flex-shrink: 1;
    overflow: hidden;
}

.xeUsageChart.is-overview-compact .info_area .info01 {
    margin-bottom: 2px;
}

.xeUsageChart.is-overview-compact .info_area .info01 dt {
    margin-top: 0 !important;
    font-size: 11px !important;
}

.xeUsageChart.is-overview-compact .info_area .info01 dd {
    font-size: clamp(22px, 3.2vw, 34px) !important;
    letter-spacing: -1px !important;
    margin: 2px 0 6px 0 !important;
    line-height: 1 !important;
}

.xeUsageChart.is-overview-compact .info_area .info01 dd span {
    font-size: 12px !important;
    margin: 0 0 0 2px !important;
}

.xeUsageChart.is-overview-compact .selfRateValue {
    font-size: clamp(22px, 3.2vw, 34px) !important;
}

.xeUsageChart.is-overview-compact .info_area .info-style {
    padding-left: 24px !important;
    padding-bottom: 4px !important;
    background-size: 18px auto !important;
    background-position: left center !important;
}

.xeUsageChart.is-overview-compact .info_area .info-style dt {
    font-size: 10px !important;
    padding-bottom: 1px !important;
}

.xeUsageChart.is-overview-compact .info_area .info-style dd {
    font-size: 12px !important;
    white-space: nowrap;
}

.xeUsageChart.is-overview-compact .pm-energy-text {
    font-size: 12px !important;
}

.xeUsageChart.is-overview-compact .pm-energy-amount {
    font-size: 10px !important;
}

.xeUsageChart.is-overview-compact .img_area {
    position: relative;
    width: 40% !important;
    max-width: 120px !important;
    flex: 0 0 auto;
    aspect-ratio: 1;
    overflow: hidden;
    margin-left: auto;
    margin-right: 4px;
}

/* 동심 정렬: transform 미사용 (bg1/bg2 rotate 애니메이션과 충돌 방지) */
.xeUsageChart.is-overview-compact .bg1,
.xeUsageChart.is-overview-compact .bg2,
.xeUsageChart.is-overview-compact .info04 {
    position: absolute !important;
    margin: 0 !important;
    background-size: contain !important;
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.xeUsageChart.is-overview-compact .bg1 {
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
}

.xeUsageChart.is-overview-compact .bg2 {
    top: 8% !important;
    left: 8% !important;
    width: 84% !important;
    height: 84% !important;
}

/*
 * info04(circle_bg_03): compact에서도 크기는 조정됨.
 * PNG 캔버스 242 중 흰 원은 182(+오프셋)라 PC는 박스를 bg1 대비 242/251·위치 보정함.
 */
.xeUsageChart.is-overview-compact .info04 {
    top: calc(24 / 250 * 100%) !important;
    left: calc(33 / 251 * 100%) !important;
    width: calc(242 / 251 * 100%) !important;
    height: calc(242 / 251 * 100%) !important;
    transform: none;
    background-size: contain !important;
    background-position: 0 0;
}

/* 흰 원 픽셀 영역(1,10)-(182,191)과 동일 스테이지 — 아이콘·텍스트 공통 좌표 */
.xeUsageChart.is-overview-compact .info04-stage {
    position: absolute;
    left: calc(1 / 242 * 100%);
    top: calc(10 / 242 * 100%);
    width: calc(182 / 242 * 100%);
    height: calc(182 / 242 * 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    padding: 6% 4% 8%;
    z-index: 2;
    overflow: hidden;
}

.xeUsageChart.is-overview-compact .info04 .bld-icon {
    display: block;
    position: relative;
    left: auto;
    top: auto;
    flex: 1 1 auto;
    width: 72%;
    min-height: 0;
    margin: 0 auto;
    transform: none;
    background-image: var(--icon-bg);
    background-size: contain;
    background-position: center bottom;
    background-repeat: no-repeat;
    pointer-events: none;
}

.xeUsageChart.is-overview-compact .info04 dl {
    position: relative;
    z-index: 3;
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
    box-sizing: border-box;
    text-align: center;
}

.xeUsageChart.is-overview-compact .info04 dt {
    padding: 0 !important;
    font-size: 9px !important;
    line-height: 1.2 !important;
}

/* PC용 ::before 아이콘은 compact에서 숨김 (점처럼 붕괴되던 원인) */
.xeUsageChart.is-overview-compact .info04 dt::before {
    display: none !important;
    content: none !important;
}

.xeUsageChart.is-overview-compact .info04 dd {
    font-size: 11px !important;
    margin: 0;
}

.xeUsageChart.is-overview-compact .unit-amount-text {
    font-size: 12px !important;
}

.bld-icon {
    display: none;
}

.xeUsageChart.is-overview-compact .usage-animation-area > .ex {
    position: static !important;
    flex: 0 0 auto;
    margin: 2px 0 0 !important;
    padding: 0 4px;
    font-size: 9px !important;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    bottom: auto !important;
    left: auto !important;
}

.xeUsageChart.is-overview-compact .usage-animation-area > .ex i {
    font-size: 12px;
    vertical-align: middle;
}
</style>
